export default __webpack_public_path__ + "static/media/p1-2.91bbed2d.png";